export enum ChannelType {
  Sms = 'sms',
  Landline = 'landline',
  Twilio = 'twilio',
  Facebook = 'facebook',
  DirectMessage = 'direct message',
  Secure = 'secure',
  Rhinogram = 'rhinogram',
  Instagram = 'instagram',
}
